import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import {isEmpty} from "../util/is";
import { makeStyles } from '@mui/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Checkbox from '@mui/material/Checkbox';
import {Colors} from "../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import {GlobalConstants} from "../data/GlobalConstants";
import Emitter from "../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../data/ConstantEventEmitter";
import {formatDay} from "../util/functions";
import {clientesService} from "../services/apiClientes";
import {useDispatch} from "react-redux";
import {alertQuestionService} from "../services/alertQuestionService";
import '../../src/components/styles.css'

const CheckboxList = ({list, onChange, tipo, diaSeleccionado}) => {

    const [checked, setChecked] = React.useState(null);

    const handleToggle = (value) => () => {
        setChecked(value);
    };

    const handleSaveOrden = () => {
        onChange(tipo, diaSeleccionado, Number(checked.nbOrden) + 1);
    }

    return (
        <div style={{backgroundColor: "white", borderRadius: 25}} className="p-4">
            <div className="d-flex align-items-center justify-content-between" style={{height: 60}}>
                <input className="custom-input-address mx-2 w-100" value={isEmpty(checked)? `No has seleccionado ningun item`: `Nuevo orden asignado #${Number(checked.nbOrden) + 1}`}  readOnly={true} />
                <Tooltip title="Guardar Orden" aria-label="guardarOrden" className="ml-2">
                    <a onClick={() => handleSaveOrden()}
                       className="icon-container-actions d-flex mr-0 pr-0">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}></div>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-check fa-2x"></i>
                    </a>
                </Tooltip>
                <Tooltip title="Salir" aria-label="salir" className="ml-2">
                    <a onClick={() => Emitter.emit(ConstantEventEmitter.eventCloseModalDiasEntregaVisita)}
                       className="icon-container-actions d-flex mr-0 pr-0">
                        <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}></div>
                        <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"></i>
                    </a>
                </Tooltip>
            </div>
            <List dense  style={{maxHeight: 400, overflowY: "scroll", width: '100%'}} >
            {list.map((value) => {
                const labelId = `checkbox-list-secondary-label-${value.id}-VisitaEntrega`;
                return (
                    <ListItem key={`keyCheckVisitaEntrega-${value.id}`} button>
                        <ListItemAvatar>
                            <div className="d-flex align-items-center justify-content-center font-weight-bold" style={{width: 40, height: 40, borderRadius: "100%", color: "white", backgroundColor: `${Colors.COLOR_BLUE_THEME}`}}>{value.nbOrden}</div>
                        </ListItemAvatar>
                        <ListItemText id={labelId} primary={`${value.idPuntoVenta} - ${value.nmNegocio}`} />
                        <ListItemSecondaryAction>
                            <Checkbox
                                edge="end"
                                onChange={handleToggle(value)}
                                checked={value?.id === checked?.id}
                                inputProps={{ 'aria-labelledby': labelId }}
                            />
                        </ListItemSecondaryAction>
                    </ListItem>
                );
            })}
        </List>
        </div>
    );
}

const OrdenDiasVisita = ({diasVisita = [], diasEntrega = [], ordenVisita = [], ordenEntrega = [], idZona, onChange, customError = null, required = false, showDivider = true, tab = "PUNTOSVENTA", disabled = false, hideTitle = false}) => {

    const dispatch = useDispatch();
    const [ stateTipoAndOpenModal, setStateTipoAndOpenModal ] = useState({ stateModalOrdenEntregaVisita: false, stateTipo: null, diaSeleccionado: null, dataList: [] })
    const { stateModalOrdenEntregaVisita, stateTipo, diaSeleccionado, dataList } = stateTipoAndOpenModal;

    const getTypeVisitaEntrega = ({type, dia, idZona}) => {

      clientesService.getListOrdenByTypeVisitaEntrega({type, dia: formatDay(dia), zona: idZona, tab }).then(
        response => {

          const { status, msg, data } = response;

          if (status) {

            if(data?.length > 0){
              setStateTipoAndOpenModal({
                stateModalOrdenEntregaVisita: true,
                stateTipo: type,
                diaSeleccionado: dia,
                dataList: data
              })
            }
            else{
              onChange(type, dia, 1);
            }

          } else {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
          }


        },
        error => {
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
        }
      )

    }

    const handleOpenModalByType = (type, dia, tieneAsignado = true) => {

      if(!tieneAsignado){

        getTypeVisitaEntrega({type, dia: dia, idZona})

        return;
      }


      alertQuestionService.showAlert({title: `Editar o eliminar día seleccionado`, question: `¿Desea editar o eliminar el día seleccionado?`,
        message: `Recuerda que al cambiar el estado del registro afectara las gestiones que asocien el registro seleccionado`,
        actionBtnAceptar: () => {

          onChange(type, dia, null);

          alertQuestionService.clear();

        },
        actionBtnCancelar: () => {

          getTypeVisitaEntrega({type, dia: dia, idZona})

          alertQuestionService.clear();

        },
        labelAceptar: "Eliminar",
        labelCancelar: "Editar",
        type: GlobalConstants.alertInfo
    });




    }

    useEffect(() => {
        return () => {
            Emitter.off(ConstantEventEmitter.eventCloseModalDiasEntregaVisita);
        }
    },[])

    useEffect(() => {

        Emitter.on(ConstantEventEmitter.eventCloseModalDiasEntregaVisita, () => setStateTipoAndOpenModal({stateModalOrdenEntregaVisita: false, stateTipo: null, diaSeleccionado: null, dataList: []}));

    }, [])

    return(
        <>

          {
            showDivider &&
            <header className="mx-2 text-center text-muted content-divider divider-form">
              <span/>
            </header>
          }

          {
            !hideTitle &&
            <div className="py-2 d-flex align-items-center justify-content-center">
                <div className="mr-2 d-flex align-items-center">
                    <div className="circulo-indicador-visita"/>
                    <div className="ml-1" style={{fontSize: "1rem"}}>Días y orden de visita</div>
                </div>
                <div className="ml-2 d-flex align-items-center">
                    <div className="circulo-indicador-entrega"/>
                    <div className="ml-1" style={{fontSize: "1rem"}}>Días y orden de entrega</div>
                </div>
            </div>
          }

            <div className={`${disabled ? 'is-disabled' : ''}`}>
                <div className="row align-items-center justify-content-center mt-3 mb-3">
                    <div className="text-center ml-2"><p className="fontSize1rem"><strong>LU</strong></p>
                        <div className="d-flex align-items-center justify-content-center">

                            {
                                isEmpty(diasVisita[0]) || diasVisita[0] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 0,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 0)} className="circulo-big-indicador-visita-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenVisita[0]}</div>
                            }
                            {
                                isEmpty(diasEntrega[0]) || diasEntrega[0] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 0,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 0)} className="circulo-big-indicador-entrega-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenEntrega[0]}</div>
                            }

                        </div>
                    </div>
                    <div className="text-center ml-2"><p className="fontSize1rem"><strong>MA</strong></p>
                        <div className="d-flex align-items-center justify-content-center">
                            {
                                isEmpty(diasVisita[1]) || diasVisita[1] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 1,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 1)} className="circulo-big-indicador-visita-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenVisita[1]}</div>
                            }
                            {
                                isEmpty(diasEntrega[1]) || diasEntrega[1] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 1,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 1)} className="circulo-big-indicador-entrega-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenEntrega[1]}</div>
                            }
                        </div>
                    </div>
                    <div className="text-center ml-2"><p className="fontSize1rem"><strong>MI</strong></p>
                        <div className="d-flex align-items-center justify-content-center">
                            {
                                isEmpty(diasVisita[2]) || diasVisita[2] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 2,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 2)} className="circulo-big-indicador-visita-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenVisita[2]}</div>
                            }
                            {
                                isEmpty(diasEntrega[2]) || diasEntrega[2] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 2,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 2)} className="circulo-big-indicador-entrega-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenEntrega[2]}</div>
                            }
                        </div>
                    </div>
                    <div className="text-center ml-2"><p className="fontSize1rem"><strong>JU</strong></p>
                        <div className="d-flex align-items-center justify-content-center">
                            {
                                isEmpty(diasVisita[3]) || diasVisita[3] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 3,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 3)} className="circulo-big-indicador-visita-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenVisita[3]}</div>
                            }
                            {
                                isEmpty(diasEntrega[3]) || diasEntrega[3] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 3,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 3)} className="circulo-big-indicador-entrega-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenEntrega[3]}</div>
                            }
                        </div>
                    </div>
                    <div className="text-center ml-2"><p className="fontSize1rem"><strong>VI</strong></p>
                        <div className="d-flex align-items-center justify-content-center">
                            {
                                isEmpty(diasVisita[4]) || diasVisita[4] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 4,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 4)} className="circulo-big-indicador-visita-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenVisita[4]}</div>
                            }
                            {
                                isEmpty(diasEntrega[4]) || diasEntrega[4] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 4,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 4)} className="circulo-big-indicador-entrega-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenEntrega[4]}</div>
                            }
                        </div>
                    </div>
                    <div className="text-center ml-2"><p className="fontSize1rem"><strong>SA</strong></p>
                        <div className="d-flex align-items-center justify-content-center">
                            {
                                isEmpty(diasVisita[5]) || diasVisita[5] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 5,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 5)} className="circulo-big-indicador-visita-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenVisita[5]}</div>
                            }
                            {
                                isEmpty(diasEntrega[5]) || diasEntrega[5] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 5,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 5)} className="circulo-big-indicador-entrega-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenEntrega[5]}</div>
                            }
                        </div>
                    </div>
                    <div className="text-center ml-2"><p className="fontSize1rem"><strong>DO</strong></p>
                        <div className="d-flex align-items-center justify-content-center">
                            {
                                isEmpty(diasVisita[6]) || diasVisita[6] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 6,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeVisita, 6)} className="circulo-big-indicador-visita-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenVisita[6]}</div>
                            }
                            {
                                isEmpty(diasEntrega[6]) || diasEntrega[6] === -1 ?
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 6,  false)} className="circulo-big-indicador-gray-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer"/>
                                    :
                                    <div onClick={() => handleOpenModalByType(GlobalConstants.typeEntrega, 6)} className="circulo-big-indicador-entrega-edit d-flex align-items-center justify-content-center mr-1 cursor-pointer">{ordenEntrega[6]}</div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            {
                !isEmpty(customError) && required &&
                <span className="mt-1 pl-2 titleForm panelColorError">{customError}</span>
            }

            <Modal
                size="sm"
                show={stateModalOrdenEntregaVisita}
                onHide={() => setStateTipoAndOpenModal({stateModalOrdenEntregaVisita: false, stateTipo: null, diaSeleccionado: null, dataList: []})}
                centered >
                <Modal.Body>

                    <div className="p-2">

                        <CheckboxList list={dataList} onChange={onChange} tipo={stateTipo} diaSeleccionado={diaSeleccionado} />

                    </div>

                </Modal.Body>
            </Modal>
        </>
    )

}

export default OrdenDiasVisita;
